<template>
<div>
<mu-table :showCheckbox="false" 
     style="border: 1px solid #e1e8e9;">
    <mu-thead>
        <mu-tr>
            <mu-th class="pointer">Client</mu-th>
            <mu-th class="pointer">Scan(s)</mu-th>
            <mu-th class="medium-hide">CodeBarre</mu-th>
            <mu-th >Manquants</mu-th>
        </mu-tr>
    </mu-thead>
    <mu-tbody>
        <mu-tr v-for="(item, index) in cbtable" :key="item.fk_soc" @click.native="trRoute(index)" class="pointer">
            <mu-td>{{item.cus_name}}</mu-td>
            <mu-td>{{item.barcode_scan}}</mu-td>
            <mu-td class="medium-hide">{{item.barcode_count}}</mu-td>
            <mu-td>{{ item.barcode_count - item.barcode_scan }}</mu-td>
        </mu-tr>
    </mu-tbody>
</mu-table>
</div>
</template>

<script>
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import {table, thead, tbody, tfoot, tr, td, th }    from 'muse-components/table'
import {col, row} from 'muse-components/grid'
import pagination from 'muse-components/pagination'

export default {
    name: 'scan-customer',
    props: ['cbtable', 'scanMode', 'scanControl'],
    data: function () {
        return {
            pref: this.$auth.userPref
        }
    },
    computed: {},
    methods: {
        trRoute (cus_id) {
            if( cus_id > 0 ){
                this.scanMode('vouch', cus_id)
            }
        }
    },
    components: {
        'mu-icon': icon,
        'mu-icon-button': iconButton,
        'mu-table': table, 'mu-thead': thead, 'mu-tbody': tbody, 'mu-tfoot': tfoot,
        'mu-tr': tr, 'mu-td': td, 'mu-th': th,
        'mu-pagination': pagination
    }
}
</script>

<style lang="less">
@media only screen and (max-width : 768px) {
    .medium-hide {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// Scan_customer.vue?8ec8f95e